import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortComponent implements OnInit {
  @Input()
  public get sort(): BookmarkSortModel {
    return this._sort;
  }
  public set sort(value: BookmarkSortModel) {
    this._sort = value;
    this.changeDetectorRef.markForCheck();
  }
  private _sort: BookmarkSortModel;

  @Input()
  sortOptions: BookmarkSortModel[] = [];

  @Output()
  sortChange = new EventEmitter<BookmarkSortModel>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  handleSort(option: BookmarkSortModel) {
    this.sortChange.emit(option);
  }

}
